import { Badge, Button, Card, Grid, Group, List, Text, TextInput } from '@mantine/core';
import { IconPrinter } from '@tabler/icons-react';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import NavBar from '../../components/NavBar/NavBar';
import { createAllQrPdf, createBarcodePdf } from '../../Utils/qr';
import '../Global.css';
import classes from './Bin.module.css';
import { useMediaQuery } from '@mantine/hooks';


const Bin: React.FC = () => {
    const [bin, setBin] = useState<{ location: string, styles: string[] }>();
    const [serisBin, setSerisBin] = useState<{ alphabet: string, number: number }>();
    const [binData, setBinData] = useState<any[]>([]);
    const token = useSelector((state: any) => state.user.sessionId);
    const [updateData, setUpdateData] = useState<{ binlocation: string, style_no: string }>({ binlocation: '', style_no: '' });
    const [inputTimeout, setInputTimeout] = useState<NodeJS.Timeout | null>(null);
    const [styleInputTimeout, setStyleInputTimeout] = useState<NodeJS.Timeout | null>(null);
    const isSmallScreen = useMediaQuery('(max-width: 900px)');

    // Create refs to reference the input fields
    const binRef = useRef<HTMLInputElement | null>(null);
    const styleRef = useRef<HTMLInputElement | null>(null);

    const handleBinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUpdateData({ ...updateData, binlocation: e.target.value.toUpperCase() });
        if (inputTimeout) {
            clearTimeout(inputTimeout);
        }
        const timeout = setTimeout(() => {
            if (e.target.value && styleRef.current) {
                getBinData({ location: e.target.value.toUpperCase() });
                styleRef.current.focus();
            }
        }, 150);
        setInputTimeout(timeout);
    };

    const handleStyleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUpdateData({ ...updateData, style_no: e.target.value });
        if (styleInputTimeout) {
            clearTimeout(styleInputTimeout);
        }
        const timeout = setTimeout(() => {
            if (e.target.value) {
                updateBinLocation(updateData.binlocation, e.target.value);
            }
        }, 150); // Adjust the delay time as per your scanner's speed
        setStyleInputTimeout(timeout);
    };

    const fetchBins = async () => {
        try {
            const response = await fetch('/bin/list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    page: 1,
                    limit: 10,
                    searchTerm: ''
                })
            });
            const { data, message } = await response.json();
            setBinData(data);
            if (response.status !== 200) {
                throw new Error(message);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchBins();
    }, [])

    const getBinData = async (bin: { location: string }) => {
        try {
            const response = await fetch(`/bin/getBin/${bin?.location}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            const { data, message } = await response.json();
            if (response.status !== 200) {
                throw new Error(message);
            }
            setBin({ location: data.location, styles: data.styles });
        } catch (error) {
            console.log(error);
        }
    }

    const updateBinLocation = async (binlocation: string, style_no: string) => {
        try {
            const response = await fetch('/bin/updateBin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ binlocation, style_no })
            });
            const { data, message } = await response.json();
            if (bin?.styles) {
                //check if style already exists in bin
                if (bin?.styles.includes(data.styles[0].style_no)) {
                    alert(`Style already exists in ${binlocation}.`)
                    return;
                } else {
                    setBin({ ...bin, location: data.styles[0].binlocation, styles: [...bin?.styles, data.styles[0].style_no] });
                }
            }
            if (response.status !== 200) {
                alert(message || 'Something went wrong!');
                throw new Error(message);
            }
            alert(message);
            setUpdateData({ binlocation: '', style_no: '' });
            // get focus back to updatedData.binlocation
            document.getElementById('binlocation')?.focus();
        } catch (error) {
            console.log(error);
        }
    }

    const handlePrint = async (barcode: string) => {
        await createBarcodePdf(barcode);
    }

    const handleAllQR = async () => {
        // print all qr
        if (serisBin === undefined) return;
        await createAllQrPdf(serisBin);
    }

    return (
        <div>
            <NavBar />
            <div className={'main'}>
                <h2 className={'title'}>Bin</h2>
                <Grid>
                </Grid>
                <Grid style={{ width: '100%' }}>
                    <Grid.Col offset={{ base: 0, md: 2 }} span={{ base: 12, md: 8 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginBottom: '40px', gap: '10px' }}>
                            <TextInput
                                placeholder='Enter bin location'
                                id='binlocation'
                                label='Bin Location'
                                value={updateData.binlocation}
                                onChange={handleBinChange}
                                style={{ flexGrow: 1 }}
                                ref={binRef}
                            />
                            <TextInput
                                placeholder='Enter style no'
                                label='Style No'
                                value={updateData.style_no}
                                onChange={handleStyleChange}
                                style={{ flexGrow: 1 }}
                                ref={styleRef}
                            />
                            {/* <Button onClick={()=>updateBinLocation(updateData.binlocation, updateData.style_no)}>Update</Button> */}
                        </div>
                        {bin?.location && (
                            <div className={classes.card} style={{ padding: '10px' }}>
                                <Card shadow="sm" padding="lg" radius="md" style={{ width: isSmallScreen ? '80%' : '47%', border: '1px solid #d0d0d0ff', position: 'fixed', top: '34%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                    <Group justify="space-between" mt="md" mb="xs">
                                        <Text fw={800} fz={36}>{bin?.location}</Text>
                                        <Badge color="dark" size='lg'>{bin?.styles?.length}</Badge>
                                    </Group>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Text size="sm" fw={550} color='#b4b4b4ff'>
                                            {`Bin location`}
                                        </Text><Text size="sm" fw={550} color='#b4b4b4ff'>
                                            {`Total styles`}
                                        </Text>
                                    </div>
                                    <Button onClick={() => handlePrint(bin?.location || '')} fullWidth mt="md" radius="md">
                                        <IconPrinter />Print
                                    </Button>
                                </Card>
                                <Grid style={{ width: '90%', marginTop: '180px' }}>
                                    {bin?.styles?.map((style: any, index: number) => <Grid.Col className={classes.styles} span={{ base: 12 }} key={style.style_no}>
                                        <Text fz={18}>{index + 1}.   {style.style_no}</Text>
                                        <Text fz={12} fw={550} color='#d0d0d0ff' >{style.description}</Text>
                                    </Grid.Col>)}
                                </Grid>
                            </div>)}
                    </Grid.Col>
                    <Grid.Col offset={1} span={2}>
                        <div >
                            <TextInput style={{ flexGrow: 1, width: '100%' }} value={serisBin?.alphabet || ''} label='Alphabet' placeholder='Enter aplhabet' onChange={(e) => setSerisBin(prevState => ({ ...prevState, alphabet: e.target?.value?.toLocaleUpperCase() || '', number: prevState?.number || 0 }))} />
                            <TextInput
                                style={{ flexGrow: 1, width: '100%' }}
                                label='Number'
                                placeholder='Enter number'
                                type='number'
                                onChange={(e) => {
                                    const parsedNumber = parseInt(e.target.value, 10);
                                    setSerisBin(prevState => ({
                                        ...prevState,
                                        number: isNaN(parsedNumber) ? 0 : parsedNumber,  // Default to 0 if NaN
                                        alphabet: prevState?.alphabet || ''
                                    }));
                                }}
                            />
                        </div>
                        <Button style={{ flexGrow: 1, marginTop: '25px', width: '100%' }} onClick={() => handleAllQR()}>All QR</Button>
                    </Grid.Col>
                    <div className={"footerDiv"}>
                        <div></div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', gap: '10px' }}>
                            <TextInput
                                placeholder='Search bin'
                                onChange={(e) => setBin({ location: e.target.value.toUpperCase(), styles: bin?.styles || [] })}
                                style={{ flexGrow: 1 }}
                            />
                            <Button onClick={() => bin && getBinData(bin)}>
                                Get Bin Data
                            </Button>
                        </div>
                    </div>
                </Grid>
            </div>
        </div>
    )
}


export default Bin;